import { useContext } from 'react';

import ApiContext from '../../providers/context/ApiContext/ApiContext';

export const useAPI = () => {
  return useContext(ApiContext);
};
